// The strings in this file are only for developers
const noProviderError = (item, provider = 'StytchProvider')=>`${item} can only be used inside <${provider}>.`;
const providerMustBeUniqueError = 'You cannot render a <StytchProvider> inside another <StytchProvider>.';
const cannotInvokeMethodOnServerError = (path)=>`[Stytch] Invalid server-side function call to ${path}` ;

export { cannotInvokeMethodOnServerError, noProviderError, providerMustBeUniqueError };
//# sourceMappingURL=errors.mjs.map
